// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getStorage } from '../utils/functions/localstorage';

const baseQuery = fetchBaseQuery({
  baseUrl: `${process.env.REACT_APP_API_URL_admin}/log`,
  prepareHeaders: (headers) => {
    const token = getStorage('token');
    // If we have a token set in state, let's assume that we should be passing it.
    if (token) {
      headers.set('authorization', `Bearer ${token}`);
    }

    return headers;
  },
});

export const usageHistoryApi = createApi({
  reducerPath: 'usageHistoryApi',
  baseQuery,
  endpoints: (builder) => ({
    LogUsageHistory: builder.query({
      query: (q) => {
        const params = new URLSearchParams({
          startDate: q.startDate,
          endDate: q.endDate,
          logType: q.type,
          size: String(q.size),
          page: String(q.page),
          sorgcode: q.sorgcode,
          sortBy: q.sortBy || 'createdAt',
          sortOrder: q.sortOrder || 'desc',
        });

        return `/?${params.toString()}`;
      },

    }),
    LogUsageHistoryWHT: builder.query({
      query: (q) => {
        const params = new URLSearchParams({
          startDate: q.startDate,
          endDate: q.endDate,
          logType: q.logType,
          size: String(q.size),
          page: String(q.page),
          sorgcode: q.sorgcode,
          type: q.type,
          sortBy: q.sortBy || 'createdAt',
          sortOrder: q.sortOrder || 'desc',
        });

        return `/?${params.toString()}`;
      },
    }),

  }),
});

export const { useLogUsageHistoryQuery, useLazyLogUsageHistoryQuery,useLogUsageHistoryWHTQuery,useLazyLogUsageHistoryWHTQuery} = usageHistoryApi;
// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
